import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog'; 
import {Router} from '@angular/router';
import { ApiService } from 'src/app/shared/services/api/api.service'; 
import { ReviewDialogService } from 'src/app/shared/services/matDialogUtils/review-dialog.service';

@Component({
  selector: 'app-all-reviews-desktop',
  templateUrl: './all-reviews-desktop.component.html',
  styleUrls: ['./all-reviews-desktop.component.less']
})
export class AllReviewsDesktopComponent implements OnInit {

  reviews = [];
  spinner = 'assets/image/spinner.gif';
  isReviewFetching = false;
  pageNo = 0;
  product: any;
  reviewData: any;
  currentSortType = '';
  // For Infinite Scroll
  throttle = 300;
  scrollDistance = 0.1;
  scrollUpDistance = 2;

  constructor(
      @Inject(MAT_DIALOG_DATA) public data: any, 
      private apiService: ApiService,
      private reviewDialog: ReviewDialogService, 
  ) {
  }

  ngOnInit() {
    this.product = this.data.product;
    this.reviewData = this.data.reviewsData;
    this.fetchProductReviews();
  }

  fetchProductReviews() {
    this.isReviewFetching = true;
    this.apiService.getFullReviewList(this.product.sku, this.pageNo, this.currentSortType).subscribe((response: []) => {
      this.reviews = [...this.reviews, ...response];
      this.isReviewFetching = false;
    });
  }

  changeSort(sort) {
    this.currentSortType = sort;
    this.pageNo = 0;
    this.reviews = [];
    this.fetchProductReviews();
  }

  renderPercentage(num) {
    return Number.parseFloat(num).toPrecision(2);
  }

  onScrollDown() {
    this.pageNo++;
    this.fetchProductReviews();
  }

  openWriteReviewModal() {
    const data = {
      sku: this.product.sku,
      brand: this.product.site,
      image: this.product.main_image,
      name: this.product.name,
    };
    this.reviewDialog.openMyReviewDialog(data);
  }

  openProductPage() {
    window.location.href = '/product/' + this.product.sku;
  }
}